module.exports = __webpack_public_path__ + "static/img/5.fefe4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/profile/5.png
// module id = MJZz
// module chunks = 1